import type { Camerastand } from './indeling'

/**
 * Voor afdrukken en vergelijkingen (21 oktober), alleen via de URL:
 *
 *   ?linde=0 of ?linde=1 de Matics als 3D-model of als Linde-render, los van
 *                        de schakelaar in de Instellingen
 *   ?pendel=0.27         de C-MATIC staat stil op deze fractie van zijn rondgang
 *   ?cam=x,y,z,dx,dy,dz  vaste camera in plaats van de zweefroute
 *   ?film=0 of ?film=1   het hoofdscherm realtime of als film van de zweefronde,
 *                        los van de schakelaar in de Instellingen
 *   ?tijd=12.5           de hal staat stil op dit moment van de omloop (`omloop.ts`):
 *                        trucks, pendel, deuren en de camera op de zweefroute. Zo
 *                        is een beeld van de hal naast hetzelfde beeld van de film
 *                        van de zweefronde te leggen
 *
 * Zonder parameters verandert er niets.
 */
const q = typeof location === 'undefined' ? new URLSearchParams() : new URLSearchParams(location.search)
const getallen = (s: string | null) => (s ? s.split(',').map(Number) : [])
const cam = getallen(q.get('cam'))

export const PROEF = {
  linde: q.has('linde') ? q.get('linde') !== '0' : null,
  pendel: q.has('pendel') ? Number(q.get('pendel')) : null,
  tijd: q.has('tijd') ? Number(q.get('tijd')) : null,
  film: q.has('film') ? q.get('film') !== '0' : null,
  cam: cam.length === 6 && cam.every(Number.isFinite)
    ? ({ positie: [cam[0], cam[1], cam[2]], doel: [cam[3], cam[4], cam[5]] } as Camerastand)
    : null,
}
